import { LocalStorage } from "@/assets/js/storage";
export function getInitData(fallback = true) {
  // 1. 解析服务端注入的初始化数据
  const parsedData =
    isJSONString(window.indexPageInitDataFromServer) && isEnableParse(window.indexPageInitDataFromServer)
      ? JSON.parse(window.indexPageInitDataFromServer)
      : null;

  // 3. 合并数据优先级：服务端data > 本地存储
  let initData = parsedData?.data;
  if (fallback && !initData) {
    // 2. 获取本地存储数据
    const locApiAll = LocalStorage.getItem("API_ALL");
    initData = locApiAll?.data ?? null;
  }

  // 4. 字段格式化：baseInfo 迁移到 info，删除冗余字段
  if (!isEmptyType(initData) && initData.baseInfo) {
    initData.info = initData?.info ?? initData?.baseInfo ?? {};
    delete initData.baseInfo;
  }
  return initData;
}
